// API Configuration (login-web)
// Keep compatible with the old client getApiUrl behavior.
const getBaseUrl = (): string => {
  // Preferred in this repo's docs
  if (import.meta.env.VITE_API_BASE_URL) return import.meta.env.VITE_API_BASE_URL;
  // Legacy name used in old client
  if (import.meta.env.VITE_API_URL) return import.meta.env.VITE_API_URL.replace(/\/api\/v1\/?$/, '');
  // In production behind a reverse proxy, prefer same-origin `/api/*`.
  if (import.meta.env.PROD) return '';
  // Default local API port (matches docs/local-dev.md)
  return 'http://localhost:3003';
};

export const API_BASE_URL = getBaseUrl();

export const getApiUrl = (endpoint: string): string => {
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) return endpoint;
  if (endpoint.startsWith('/api')) return `${API_BASE_URL}${endpoint}`;
  return `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;
};

